import { createContext } from 'react';
import { OrgUnitAssortment } from '@retail/mgpris/config-types';

export interface MyOrgUnitAssortmentsState {
  assortments: OrgUnitAssortment[];
  allAssortments: OrgUnitAssortment[];
}

export const MyOrgUnitAssortmentsContext = createContext<MyOrgUnitAssortmentsState | null>(null);

export const MyOrgUnitAssortmentsProvider = MyOrgUnitAssortmentsContext.Provider;
